export default __webpack_public_path__ + "static/media/pro.31c71346.svg";